import {
  FrequencyCellRenderer,
  NoteCountCellRenderer,
  DoneActionCellRenderer,
  RefusedActionCellRenderer,
} from './CellRenderer';

// todo translations
export const noteDef = {
  headerName: '',
  field: 'note_count',
  cellClass: 'no-border no-pad',
  suppressMenu: true,
  cellRendererFramework: NoteCountCellRenderer,
  width: 40,
};
export const taskDef = {
  headerName: 'Task',
  field: 'tasktext',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 160,
};
export const frequencyDef = {
  headerName: 'Frequency',
  field: 'frequency',
  cellClass: 'no-border',
  cellRendererFramework: FrequencyCellRenderer,
  suppressMenu: true,
  width: 70,
};
export const doneDef = {
  headerName: 'Done',
  field: 'done',
  cellClass: 'no-focus-outline',
  suppressMenu: true,
  cellRendererFramework: DoneActionCellRenderer,
  width: 48,
};
export const refusedCellDef = {
  headerName: 'Refused',
  field: 'refused',
  cellClass: 'no-focus-outline',
  suppressMenu: true,
  cellRendererFramework: RefusedActionCellRenderer,
  width: 55,
};
